// extracted by mini-css-extract-plugin
export var container = "_cg-0";
export var popoverContent = "_cg-1";
export var tosLink = "_cg-2";